"use client";

import { useState } from "react";
import { Search, X } from "lucide-react";
import { Input } from "./Input";
import { IconButton } from "./IconButton";

interface SearchInputProps {
  placeholder?: string;
  onSearch?: (value: string) => void;
  onChange?: (value: string) => void;
  defaultValue?: string;
  className?: string;
}

export function SearchInput({
  placeholder = "검색...",
  onSearch,
  onChange,
  defaultValue = "",
  className = "",
}: SearchInputProps) {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange?.(newValue);
  };

  const handleClear = () => {
    setValue("");
    onChange?.("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch?.(value);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <Input
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        leftIcon={<Search className="w-4 h-4" />}
      />
      {value && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2">
          <IconButton
            size="sm"
            variant="ghost"
            icon={<X className="w-3 h-3" />}
            label="검색어 지우기"
            onClick={handleClear}
          />
        </div>
      )}
    </div>
  );
}

export type { SearchInputProps };
